// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-99ed05b6] .el-table__body tr.total td.el-table__cell {\n  background-color: #cedcf2 !important;\n}\n[data-v-99ed05b6] .cell {\n  cursor: pointer;\n}\n[data-v-99ed05b6] .bj-page .el-form-item__label {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
